import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PermissionsService } from 'src/app/components/services/permissions.service';

/**
 * Guard que verifica si el usuario tiene permiso para acceder a una ruta.
 *
 * Uso en content-routes.ts / seguridad-routing.module.ts:
 *   canActivate: [AdminAuthGuard, PermissionGuard],
 *   data: { permissionKey: 'seguridad.perfiles', permissionAction: 'can_view' }
 *
 * Si no hay permisos cargados (usuario sin permisos asignados) deja pasar
 * para no romper el flujo en configuraciones de primera vez.
 */
@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {

  constructor(
    private permissionsService: PermissionsService,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const key    = route.data?.permissionKey    as string | undefined;
    const action = route.data?.permissionAction as string | undefined || 'can_view';
    const perms  = this.permissionsService.permissions;

    // Sin clave configurada en la ruta → acceso libre
    if (!key) return true;

    // Sin permisos cargados → usuario sin perfil asignado → dejar pasar
    if (!perms || Object.keys(perms).length === 0) return true;

    const allowed = this.permissionsService.can(key, action as any);
    if (!allowed) {
      this.toastr.warning('No tienes permiso para acceder a esta sección.', 'Acceso restringido', { timeOut: 3000 });
      this.router.navigate(['/inicio']);
      return false;
    }
    return true;
  }
}
